// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/auto_bid_notice_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/auto_bid_notice_model.proto.
 */
export const file_bffuser_v1_auto_bid_notice_model: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL2F1dG9fYmlkX25vdGljZV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSL1AgoXQXV0b0JpZE5vdE9yZGVyZWROb3RpY2USMwoGbWFya2V0GAEgASgOMiMuYmZmdXNlci52MS5BdXRvQmlkTm90T3JkZXJlZE1hcmtldBImCgt0YXJnZXRfZGF0ZRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSKAoJYXJlYV9jb2RlGAMgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSLQoLaXNzdWVyX3R5cGUYBCABKA4yGC5iZmZ0eXBlcy52MS5MaWNlbnNlVHlwZRIRCgl0aW1lX2NvZGUYBSABKAUSHwoEc2lkZRgGIAEoDjIRLmJmZnR5cGVzLnYxLlNpZGUSMwoGcmVhc29uGAcgASgOMiMuYmZmdXNlci52MS5BdXRvQmlkTm90T3JkZXJlZFJlYXNvbhI7Chljb3VudGVycGFydHlfaXNzdWVyX3R5cGVzGAggAygOMhguYmZmdHlwZXMudjEuTGljZW5zZVR5cGUqlgEKF0F1dG9CaWROb3RPcmRlcmVkTWFya2V0EisKJ0FVVE9fQklEX05PVF9PUkRFUkVEX01BUktFVF9VTlNQRUNJRklFRBAAEiQKIEFVVE9fQklEX05PVF9PUkRFUkVEX01BUktFVF9TUE9UEAESKAokQVVUT19CSURfTk9UX09SREVSRURfTUFSS0VUX0lOVFJBREFZEAIqxAQKF0F1dG9CaWROb3RPcmRlcmVkUmVhc29uEisKJ0FVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9VTlNQRUNJRklFRBAAEjcKM0FVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9RVUFOVElUWV9MSU1JVF9FWENFRURFRBABEi4KKkFVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9QUklDRV9DUk9TU0lORxACEjkKNUFVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9PUFBPU0lURV9BVVRPX0JJRF9SRU1BSU5TEAMSMgouQVVUT19CSURfTk9UX09SREVSRURfUkVBU09OX1BSSUNFX09VVF9PRl9SQU5HRRAEEjIKLkFVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9NQU5VQUxfQklEX0NSRUFURUQQBRI9CjlBVVRPX0JJRF9OT1RfT1JERVJFRF9SRUFTT05fREVNQU5EX0ZPUkVDQVNUX05PVF9DT05GSVJNRUQQBhI5CjVBVVRPX0JJRF9OT1RfT1JERVJFRF9SRUFTT05fTk9UX0RFTElWRVJFRF9CWV9ERUFETElORRAHEjsKN0FVVE9fQklEX05PVF9PUkRFUkVEX1JFQVNPTl9SRUZFUkVOQ0VfVkFMVUVfVU5BVkFJTEFCTEUQCBI5CjVBVVRPX0JJRF9OT1RfT1JERVJFRF9SRUFTT05fU1RFUF9DT1VOVF9MSU1JVF9FWENFRURFRBAJQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_google_type_date]);

/**
 * 自動入札が発注しなかったコマ 1 件 (受渡日・市場・エリア・発注主体・コマ・売買・
 * 理由ごとに 1 件)。表示期間内で未解消のものだけが返る。
 * Mirrors internalapi.v1.AutoBidNotOrderedNotice.
 *
 * @generated from message bffuser.v1.AutoBidNotOrderedNotice
 */
export type AutoBidNotOrderedNotice = Message<"bffuser.v1.AutoBidNotOrderedNotice"> & {
  /**
   * @generated from field: bffuser.v1.AutoBidNotOrderedMarket market = 1;
   */
  market: AutoBidNotOrderedMarket;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * 発注主体。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 4;
   */
  issuerType: LicenseType;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 5;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.Side side = 6;
   */
  side: Side;

  /**
   * @generated from field: bffuser.v1.AutoBidNotOrderedReason reason = 7;
   */
  reason: AutoBidNotOrderedReason;

  /**
   * 価格交差の相手の発注主体。理由が価格交差の時だけ入り、他の理由では空。
   * 価格交差でも、相手が発注主体区分が空欄の取り込み札だけなど示せる発注主体が無い時は空 (#10084)。
   *
   * @generated from field: repeated bfftypes.v1.LicenseType counterparty_issuer_types = 8;
   */
  counterpartyIssuerTypes: LicenseType[];
};

/**
 * Describes the message bffuser.v1.AutoBidNotOrderedNotice.
 * Use `create(AutoBidNotOrderedNoticeSchema)` to create a new message.
 */
export const AutoBidNotOrderedNoticeSchema: GenMessage<AutoBidNotOrderedNotice> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_auto_bid_notice_model, 0);

/**
 * 自動入札が発注しなかったコマの記録の市場 (JepxMarket)。
 * Mirrors internalapi.v1.AutoBidNotOrderedMarket.
 *
 * @generated from enum bffuser.v1.AutoBidNotOrderedMarket
 */
export enum AutoBidNotOrderedMarket {
  /**
   * @generated from enum value: AUTO_BID_NOT_ORDERED_MARKET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スポット市場。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_MARKET_SPOT = 1;
   */
  SPOT = 1,

  /**
   * 時間前市場。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_MARKET_INTRADAY = 2;
   */
  INTRADAY = 2,
}

/**
 * Describes the enum bffuser.v1.AutoBidNotOrderedMarket.
 */
export const AutoBidNotOrderedMarketSchema: GenEnum<AutoBidNotOrderedMarket> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_auto_bid_notice_model, 0);

/**
 * 自動入札が発注しなかった理由 (docs/specs/admin/operation/approval/approval-flow.md
 * AC-APF-069). Mirrors internalapi.v1.AutoBidNotOrderedReason.
 *
 * @generated from enum bffuser.v1.AutoBidNotOrderedReason
 */
export enum AutoBidNotOrderedReason {
  /**
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 上限数量(コマ計)の超過。締切前に分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_QUANTITY_LIMIT_EXCEEDED = 1;
   */
  QUANTITY_LIMIT_EXCEEDED = 1,

  /**
   * 自社の入札と価格交差。締切前に分かる。counterparty_issuer_types に相手が入る (示せる相手が無い時は空)。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_PRICE_CROSSING = 2;
   */
  PRICE_CROSSING = 2,

  /**
   * 反対向きの自動札が残っている。締切前に分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_OPPOSITE_AUTO_BID_REMAINS = 3;
   */
  OPPOSITE_AUTO_BID_REMAINS = 3,

  /**
   * 価格が JEPX の値域外。締切前に分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_PRICE_OUT_OF_RANGE = 4;
   */
  PRICE_OUT_OF_RANGE = 4,

  /**
   * 担当者が手で札を作ったため自動入札を止めた。締切前に分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_MANUAL_BID_CREATED = 5;
   */
  MANUAL_BID_CREATED = 5,

  /**
   * 需要想定が確定しなかった。締切の時点で分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_DEMAND_FORECAST_NOT_CONFIRMED = 6;
   */
  DEMAND_FORECAST_NOT_CONFIRMED = 6,

  /**
   * 締切までに JEPX に届かなかった。締切の時点で分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_NOT_DELIVERED_BY_DEADLINE = 7;
   */
  NOT_DELIVERED_BY_DEADLINE = 7,

  /**
   * 基準の値を取得できなかった。締切の時点で分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_REFERENCE_VALUE_UNAVAILABLE = 8;
   */
  REFERENCE_VALUE_UNAVAILABLE = 8,

  /**
   * 階段数の上限超過 (AC-APF-073。スポットのみ)。締切前に分かる。
   *
   * @generated from enum value: AUTO_BID_NOT_ORDERED_REASON_STEP_COUNT_LIMIT_EXCEEDED = 9;
   */
  STEP_COUNT_LIMIT_EXCEEDED = 9,
}

/**
 * Describes the enum bffuser.v1.AutoBidNotOrderedReason.
 */
export const AutoBidNotOrderedReasonSchema: GenEnum<AutoBidNotOrderedReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_auto_bid_notice_model, 1);

